import { OrderingHoliday } from 'kiolyn-api';
import { parseInt } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment-timezone';
import { defaultTimezone } from '../models/Constants';

export default function inWorkingHoursHoliday(
  holidays?: OrderingHoliday[],
  date?: Date,
  timezone?: string
): [boolean, OrderingHoliday?] {
  if (holidays === undefined || isEmpty(holidays)) {
    return [false];
  }
  const momentByTimezone = (d?: Date | string | any) =>
    moment(d).tz(timezone || defaultTimezone);
  let mDate = momentByTimezone(date?.toString());
  const holiday = holidays.find(
    h => momentByTimezone(h.date).dayOfYear() === mDate.dayOfYear()
  );
  if (holiday === undefined) {
    return [false];
  } else if (!holiday.is_working) {
    return [false, holiday];
  }
  const convertTime = (time?: string) => {
    if (!time) return undefined;
    let storeTime = mDate.clone();
    if (time) {
      const arr = time.split(':').map(parseInt);
      storeTime.set({ hours: arr[0], minutes: arr[1] }).startOf('minute');
    }

    return storeTime;
  };
  const from1 = convertTime(holiday.from_1);
  const to1 = convertTime(holiday.to_1);
  const from2 = convertTime(holiday.from_2);
  const to2 = convertTime(holiday.to_2);

  return [mDate.isBetween(from1, to1) || mDate.isBetween(from2, to2), holiday];
}
